import { Injectable } from "@angular/core";
import { ApiService } from "../base/api-base.service";
import { NetworkStatusService } from "../network-status.service";
import { LoginUserContractService, LoginUserServiceBase } from "../interfaces/login-user-contract.service";
import { LoginUserOfflineService } from "../offline/login-user-offline.service";
import { LoginUserOnlineService } from "./login-user-online.service";
import { User, UserTenantAttribute } from "../../_objects/user";

@Injectable({
  providedIn: "root"
})
export class LoginUserService extends ApiService<LoginUserServiceBase> implements LoginUserContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: LoginUserOfflineService,
    protected onlineService: LoginUserOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  public get loginUser(): User {
    return this.service.loginUser;
  }
  public get tenantAttribute(): UserTenantAttribute {
    return this.service.tenantAttribute;
  }

  public get tenantId(): string {
    return this.service.tenantId;
  }

  public get userId(): string {
    return this.service.userId;
  }

  public isAdminRole(): boolean {
    return this.service.isAdminRole();
  }

  public isTenantAdminRole(): boolean {
    return this.service.isTenantAdminRole();
  }

  public isGuestRole(): boolean {
    return this.service.isGuestRole();
  }
}
